// @flow

const colors = {
  white: "#FFFFFF",
  maroon: "#7B2431",
  orange: "#FF6D00",
  darkYellow: "#FFD600",
  red: "#D00000",
  yellow: "#FFFF00",
  black: "#000",
  blue: "#3757DF",
  darkBlue: "#012345",
  whiteGrey: "#F9F9F9",
  lightGrey: "#F4F4F4",
  mediumLightGrey: "#EEEEEE",
  mediumGrey: "#CECECE",
  mediumDarkGrey: "#B9B9B9",
  darkGrey: "#939598",
  lightRose: "#eedddd",
  redShadow: "rgba(189, 120, 133, .50)",
  greyShadow: "rgba(0, 0, 0, .10)"
};

const borderColorProperties = {
  borderColor: value => `border-color: ${value};`,
  borderColorL: value => `border-left-color: ${value};`,
  borderColorT: value => `border-top-color: ${value};`,
  borderColorR: value => `border-right-color: ${value};`,
  borderColorB: value => `border-bottom-color: ${value};`
};

const colorProperties = {
  color: value => `color: ${value};`,
  backgroundColor: value => `background-color: ${value};`,
  outlineColor: value => `outline-color: ${value};`,
  ...borderColorProperties
};

const genColorExtender = (colorPropertiesList = []) => {
  return props => {
    let styles = "";

    colorPropertiesList.forEach(colorProperty => {
      const colorValue = colors[props[colorProperty]];
      const styleFunc = colorProperties[colorProperty];

      if (styleFunc && colorValue) {
        styles += styleFunc(colorValue);
      }
    });

    return styles;
  };
};

const borderPropertiesList = Object.keys(borderColorProperties);
const allPropertiesList = Object.keys(colorProperties);

const fullColorExtender = genColorExtender(allPropertiesList);
const riskColorMapping = ["yellow", "darkYellow", "orange", "red"];
const riskColorHexMapping = riskColorMapping.map(key => colors[key]);

export default colors;
export {
  genColorExtender,
  fullColorExtender,
  borderPropertiesList,
  allPropertiesList,
  riskColorMapping,
  riskColorHexMapping
};



// WEBPACK FOOTER //
// ./src/common/colors.js